import { type ReactNode, useState } from 'react';

import { OptionalPortalContainerContext } from '@/library/portal/OptionalPortalContainerContext';

/**
 * UG-4769 — dialog-side provider for {@link OptionalPortalContainerContext},
 * extracted at its second hand-copied instance (ManageEmployeesDialog was the
 * first): popup layers opened from dialog content must portal INSIDE the
 * dialog subtree or the Base UI dialog treats them as outside content and
 * blocks their pointer events. Wrap the dialog's body directly inside
 * `DialogContent`; the zero-box `display: contents` host div keeps the
 * dialog's own layout untouched.
 */
export const DialogPortalLayer = ({ children }: { children: ReactNode }) => {
  const [portalHost, setPortalHost] = useState<HTMLElement | null>(null);

  return (
    <>
      <div ref={setPortalHost} className="contents" data-slot="dialog-portal-host" />
      <OptionalPortalContainerContext.Provider value={portalHost}>{children}</OptionalPortalContainerContext.Provider>
    </>
  );
};
